<template>
 <div class="progress-bar flex mb-12">
    <div class=" w-1/3 inline mr-6">
      <div class="bar bg-progress-bar"></div>
      <span class="text-gray-300" :class="{'active': step === 1}"> 1. Select Repository</span>
    </div>
    <div class=" w-1/3 inline mr-6">
      <div class="bar" :class="{'bg-progress-bar': step > 1, 'bg-gray-300': step <= 1 }"></div>
      <span class="text-gray-300" :class="{'active': step === 2}">2. Choose Project Type</span>
    </div>
    <div class=" w-1/3 inline">
      <div class="bar" :class="{'bg-progress-bar': step > 2, 'bg-gray-300': step <= 2 }"></div>
      <span class="text-gray-300" :class="{'active': step === 3 }"> 3. Project Settings</span>
     </div>
  </div>
</template>

<script>

export default {
  name: 'ProgressBar',
  props: {
    step: {
      type: Number,
      required: true
    }
  }

}
</script>

<style scoped lang="scss">
.progress-bar{
  .bar{
    height:8px;
    // background-color:#E5E5E5;
  }
  .active{
    color: #313131;
  }
}
</style>
